import type { Contact } from "../types";
import { ContactCreate } from "./ContactCreate";
import { ContactEdit } from "./ContactEdit";
import { ContactList } from "./ContactList";
import { ContactShow } from "./ContactShow";

export default {
  list: ContactList,
  show: ContactShow,
  edit: ContactEdit,
  create: ContactCreate,
  recordRepresentation: (record: Contact) => {
    const parts = [record?.academic_title, record?.first_name, record?.last_name].filter(Boolean);
    // Nur akademischer Titel vor dem Namen – die Funktion (z. B. „Inhaberin“) gehört nicht in den Namen
    return parts.join(" ").trim() || "—";
  },
};
